import { render, staticRenderFns } from "./JdbcSettingView.vue?vue&type=template&id=082dca99&scoped=true"
import script from "./JdbcSettingView.ts?vue&type=script&lang=ts&external"
export * from "./JdbcSettingView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082dca99",
  null
  
)

export default component.exports